import { Colors } from '@microfrontends/react-components'
import styled from 'styled-components'

export const STContainer = styled.div``

export const STBanner = styled.div`
	display: flex;
	justify-content: center;
	position: relative;
	width: 100%;
	overflow: hidden;
	background: #205aff;
	@media (max-width: 767px) {
		margin-top: -12px;
		border-radius: 12px 12px 0 0;
	}

	div {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;

		@media (max-width: 1025px) {
			padding: 32px;
		}

		@media (max-width: 769px) {
			padding: 16px;
		}

		@media (max-width: 426px) {
			flex-direction: column;
			padding: 0;
		}

		svg {
			@media (max-width: 426px) {
				width: 247px;
				min-width: 247px;
				height: 218px;
			}
		}

		div {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
			gap: 16px;

			@media (max-width: 1441px) {
				width: 604px;
			}

			@media (max-width: 426px) {
				width: 100%;
				gap: 8px;
				align-items: center;
				height: fit-content;
				margin-top: 24px;
			}

			p {
				margin: 0;
				font-family: 'Dela Gothic One';
				font-style: normal;
				font-weight: 400;
				font-size: 60px;
				line-height: 68px;

				&:nth-of-type(1) {
					color: #ffffff;

					span {
						display: block;
					}
				}

				&:nth-of-type(2) {
					color: #ff7d55;
				}

				@media (max-width: 1025px) {
					font-size: 48px;
				}

				@media (max-width: 769px) {
					font-size: 40px;
					line-height: 60px;
				}

				@media (max-width: 426px) {
					text-align: center;
					font-size: 28px;
					line-height: 32px;
				}
			}
		}
	}
`

export const STContent = styled.div`
	position: relative;
	padding: 48px 0;

	@media (max-width: 769px) {
		padding: 40px 0;
	}

	@media (max-width: 426px) {
		padding: 24px 0;
	}
`

export const STTitle = styled.div`
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 40px;
	line-height: 58px;
	text-align: center;
	color: ${Colors.darkBlue};

	@media (max-width: 769px) {
		font-size: 32px;
		line-height: 46px;
	}

	@media (max-width: 426px) {
		font-size: 20px;
		line-height: 28px;
	}
`

export const STSubTitle = styled.div`
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 19px;
	line-height: 28px;
	color: ${Colors.darkBlue};
	min-width: max-content;
`

export const STDescription = styled.div<{ textAlign?: string }>`
	font-family: 'Inter';
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	text-align: ${({ textAlign }) => textAlign || 'unset'};
	color: ${Colors.darkBlue};

	margin-top: 8px;
`

export const STEventHot = styled.div`
	margin: 24px 0 40px;
	padding: 24px;
	border: 1px solid #efefef;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
	border-radius: 6px;

	@media (max-width: 426px) {
		margin: 8px 0 24px;
		padding: 16px;
	}
`

// card event
export const STHeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
`

export const STDivider = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;

	div:nth-of-type(1) {
		width: 12px;
		height: 12px;
		background: ${Colors.primary};
		border-radius: 50%;
	}

	div:nth-of-type(2) {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 4px;

		hr {
			width: 100%;
			height: 2px;
			color: #efefef;
			margin: 0;
		}
	}
`

export const STEventWrapper = styled.div`
	margin-top: 16px;
	display: flex;
	gap: 16px;
	flex-wrap: wrap;

	@media (max-width: 769px) {
		flex-direction: column;
	}
`

export const STButton = styled.div`
	margin-top: 16px;
	width: 100%;
	display: flex;
	justify-content: center;

	@media (max-width: 769px) {
		margin-top: 32px;
	}
`
